import home from "./views/home.vue";
import about from "./views/about.vue";
import agreement from "./views/agreement.vue";
import commercial from "./views/commercial.vue";
import legal from "./views/legal.vue";

// import store from "@/store.js";

const routes = [
  {
    path: "/",
    name: "home",
    component: home
  },
  {
    path: "/about",
    name: "about",
    component: about
  },
  {
    path: "/agreement",
    name: "agreement",
    component: agreement
  },
  {
    path: "/legal",
    name: "legal",
    component: legal
  },
  {
    path: "/commercial",
    name: "commercial",
    component: commercial
  }
];

export default routes;
